import { MutableRefObject, createContext } from 'react';

type RefContextType = {
  ref: MutableRefObject<any>;
};

export default createContext<RefContextType | null>(null);
